import React, { useEffect } from 'react'
import { Container, Row, Col } from 'reactstrap';
import AppBreadcrumb from '../../components/ui/AppBreadcrumb';
import EditUserForm from '../../components/client_admins/EditUserForm';
import { CLIENT_ADMIN_USERS } from '../../navigation/ROUTE_CONSTANTS';


function ClientAdminEditUser() {

    useEffect(() => {
        document.title = process.env.REACT_APP_SITE_TITLE + ' - Edit user ';
    });

    return (
        <Container className='mb-5 pb-5'>
            <Row>
                <Col>
                    <AppBreadcrumb headText="Edit User" crumbList={[{ linkTo: CLIENT_ADMIN_USERS, label: 'Users' }]} />
                </Col>
            </Row>
            <EditUserForm />
        </Container>
    )
}

export default ClientAdminEditUser